import React, { useState, useEffect } from "react";
//import './App.css';
import Axios from "axios";
import { Outlet, Navigate, useParams, Link } from "react-router-dom";
import { useAuth } from "./Auth";

export const RequireAuth = ({ children }) => {
  console.log("REQUIREEE AUTHh");
  const auth = useAuth();

  console.log("userrrrr" + auth.user);
  if (!auth.user) {
    return <Navigate to="/" />;
  }

  return children;
};
